module.exports = __webpack_public_path__ + "img/18.fe8c4e45.svg";